import { useState, useEffect, FC, ReactNode } from 'react';
import { Route, Switch, Redirect, RouteComponentProps } from 'react-router-dom';
import { Routes } from './routes';
import { Container } from 'react-bootstrap';
import OneSignal from 'react-onesignal';
import CustomerDetailPage from './pages/Customers/CustomerDetailPage';
import DashboardPage from './pages/DashboardPage';
import VisitReportPage from './pages/VisitReportPage';
import CustomerPage from './pages/Customers/CustomerPage';
import SelectOrganization from './components/Organizations/SelectOrganization';
import SettingsPage from './pages/SettingsPage';
import Preloader from './components/Preloader';
import Login from './components/Profile/Login';
import HomePage from './pages/HomePage';
import ResponsiveNavbar from './components/Common/Navbar';
import AgentVisitsPage from './pages/AgentVisitsPage';
import Settings from './common/Settings';
import AgentsPage from './pages/Agents/AgentsPage';
import AgentDetailsPage from './pages/Agents/AgentDetailsPage';
import ReportDemoPage from './pages/ReportDemoPage';
import PlacesByAgentsPage from './pages/PlacesByAgentsPage';
import NewPlacesPage from './pages/NewPlacesPage';

interface RouteWithSidebarProps {
    component: FC<RouteComponentProps<any>>;
    path: string;
    exact?: boolean;
}

const RouteWithSidebar: FC<RouteWithSidebarProps> = ({ component: Component, ...rest }) => {
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setLoaded(true), 1000);
        return () => clearTimeout(timer);
    }, []);

    return (
        <Route
            {...rest}
            render={(props) => (
                <>
                    <Preloader show={!loaded} />
                    <ResponsiveNavbar />
                    <Container fluid className="px-0 pt-3">
                        <Component {...props} />
                    </Container>
                </>
            )}
        />
    );
};

const App: FC = () => {
    const initializeOneSignal = async () => {
        try {
            await OneSignal.init({
                appId: Settings.OneSignalAppId,
                allowLocalhostAsSecureOrigin: true,
            });
            OneSignal.Slidedown.promptPush();
        } catch (error) {
            // OneSignal initialization error - continue without it
        }
    };

    useEffect(() => {
        initializeOneSignal();
    }, []);

    return (
        <Switch>
            <RouteWithSidebar exact path={Routes.VehicleDetails.path} component={HomePage} />
            <RouteWithSidebar exact path={Routes.Search.path} component={HomePage} />
            <RouteWithSidebar exact path={Routes.VehicleVisits.path} component={HomePage} />
            <RouteWithSidebar exact path={Routes.Home.path} component={HomePage} />
            <RouteWithSidebar exact path={Routes.CustomerDetails.path} component={CustomerDetailPage} />
            <RouteWithSidebar exact path={Routes.Dashboard.path} component={DashboardPage} />
            <RouteWithSidebar exact path={Routes.chat.path} component={HomePage} />
            <RouteWithSidebar exact path={Routes.visitReport.path} component={VisitReportPage} />
            <RouteWithSidebar exact path={Routes.reportDemo.path} component={ReportDemoPage} />
            <RouteWithSidebar exact path={Routes.PlaceDetails.path} component={HomePage} />
            <RouteWithSidebar exact path={Routes.Customers.path} component={CustomerPage} />
            <RouteWithSidebar exact path={Routes.Places.path} component={HomePage} />
            <RouteWithSidebar exact path={Routes.Agents.path} component={AgentsPage} />
            <RouteWithSidebar exact path={Routes.AgentDetails.path} component={AgentDetailsPage} />
            <Route exact path={Routes.SelectOrganization.path} component={SelectOrganization} />
            <RouteWithSidebar exact path={Routes.Settings.path} component={SettingsPage} />
            <RouteWithSidebar exact path={Routes.agentVisitsReport.path} component={AgentVisitsPage} />
            <RouteWithSidebar exact path={Routes.placesByAgentsReport.path} component={PlacesByAgentsPage} />
            <RouteWithSidebar exact path={Routes.newPlacesReport.path} component={NewPlacesPage} />
            <Route path={Routes.SignIn.path} component={Login} />
            <Redirect to={Routes.SignIn.path} />
        </Switch>
    );
};

export default App;
